import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

const { fieldContext, formContext } = createFormHookContexts();
const {
  useAppForm: usePaymentMethodForm,
  withForm: withPaymentMethodForm,
  withFieldGroup: withPaymentMethodFieldGroup,
} = createFormHook({
  fieldComponents: {},
  formComponents: {},
  fieldContext,
  formContext,
});

export { usePaymentMethodForm, withPaymentMethodForm, withPaymentMethodFieldGroup };
